import { render, staticRenderFns } from "./Briefings.vue?vue&type=template&id=17f5b6c8&"
import script from "./Briefings.vue?vue&type=script&lang=js&"
export * from "./Briefings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports